module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAiElEQVRIS+3TQQ6AIAwEQPhTf2f0It/rl8SQGBNCoVsQT3g0zQ7dgHeTPz853y1Abfi/ipg5xBg39UjYQCCiPY1mG3yEvOEFkH4MIlm4CAwgRXgV6EDE8CZgQKrhKgAgzXAIaCBqOAwIyElEB/IkTC/5ucIXGm7aADmtNGPaoAdZgNraqkit6AamB1AZ4oHmGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/login/images/arrowDown@2x.png
// module id = SoHg
// module chunks = 27